// import React, { useEffect } from "react";
// import { loadTap } from "@tap-payments/js-sdk";

// const PaymentCardInterface = () => {
//   useEffect(() => {
//     const initializeTap = async () => {
//       try {
//         const tap = await loadTap("YOUR_TAP_PUBLIC_KEY", "KWD"); // Replace with your public key & currency

//         // Create card fields
//         tap.card.create({
//           style: {
//             base: {
//               color: "#000",
//               fontSize: "16px",
//               "::placeholder": { color: "#bbb" },
//             },
//           },
//           labels: {
//             cardNumber: "Card Number",
//             expiryDate: "MM/YY",
//             cvv: "CVV",
//             cardHolder: "Card Holder Name",
//           },
//           brands: ["VISA", "MASTERCARD", "AMEX", "MADA"],
//         });

//         // Mount card fields
//         tap.card.mount("#tap-card-element");
//       } catch (error) {
//         console.error("Error initializing Tap:", error);
//       }
//     };

//     initializeTap();
//   }, []);

//   const handlePayment = async () => {
//     try {
//       const response = await tap.card.charge({
//         amount: 50, // Example amount
//         currency: "KWD",
//         threeDSecure: true,
//         description: "Test payment",
//         redirect: { url: "https://your-redirect-url.com" }, // Replace with your URL
//       });

//       console.log("Payment Response:", response);
//     } catch (error) {
//       console.error("Payment Error:", error);
//     }
//   };

//   return (
//     <div>
//       <div id="tap-card-element" style={{ width: "100%" }}></div>
//       <button
//         onClick={handlePayment}
//         style={{ marginTop: "20px", padding: "10px 20px" }}
//       >
//         Pay Now
//       </button>
//     </div>
//   );
// };

// export default PaymentCardInterface;

import React, { useEffect, useState } from "react";

const PaymentCardInterface = () => {
  const [sdkLoaded, setSdkLoaded] = useState(false);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.tabby.ai/tabby-promo.js"; // Tap Payment SDK URL
    script.async = true;
    script.onload = () => setSdkLoaded(true);
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const handlePayment = async () => {
    if (!sdkLoaded) {
      alert("Tap SDK is not loaded yet!");
      return;
    }

    const paymentData = {
      amount: 50.0, // Example amount
      currency: "KWD",
      threeDSecure: true,
      save_card: false,
      description: "Test Payment",
      statement_descriptor: "Test Store",
      customer: {
        first_name: "John",
        email: "john@example.com",
        phone: {
          country_code: "965",
          number: "12345678",
        },
      },
      source: { id: "src_all" },
      redirect: { url: "https://your-redirect-url.com" }, // Replace with actual redirect URL
    };

    try {
      const response = await fetch("https://api.tap.company/v2/charges", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer YOUR_SECRET_KEY", // Replace with your Tap secret key
        },
        body: JSON.stringify(paymentData),
      });

      const result = await response.json();
      if (result.transaction) {
        window.location.href = result.transaction.url;
      } else {
        console.error("Payment failed:", result);
      }
    } catch (error) {
      console.error("Error processing payment:", error);
    }
  };

  return (
    <div>
      <div
        id="tap-card-element"
        style={{ width: "100%", height: "50px", border: "1px solid #ccc" }}
      >
        {/* Tap payment iframe will be loaded here */}
      </div>
      <button
        onClick={handlePayment}
        style={{ marginTop: "20px", padding: "10px 20px" }}
      >
        Pay Now
      </button>
    </div>
  );
};

export default PaymentCardInterface;
